import { ORM } from 'redux-orm';

import {
  Activity,
  Attachment,
  Board,
  BoardMembership,
  Card,
  CardPointData,
  CardPointAdvancedData,
  CardPointArchivedData,
  ContentCardDefault,
  ContentType,
  ContentViewPlan,
  DampingCoefficient,
  EmployeePlan,
  Label,
  List,
  ListReportData,
  Notification,
  PointSystem,
  Project,
  ProjectManager,
  Task,
  User,
} from './models';

const orm = new ORM({
  stateSelector: (state) => state.orm,
});

orm.register(
  User,
  Project,
  ProjectManager,
  Board,
  BoardMembership,
  PointSystem,
  EmployeePlan,
  DampingCoefficient,
  ContentViewPlan,
  ContentCardDefault,
  ContentType,
  Label,
  List,
  ListReportData,
  Card,
  CardPointData,
  CardPointAdvancedData,
  CardPointArchivedData,
  Task,
  Attachment,
  Activity,
  Notification,
);

export default orm;
